import React from 'react';
import PropTypes from 'prop-types';
import Pagination from '@fountain/ui-kit/components/pagination';

import './styles.pcss';

function OpeningsDirectoryIndexPagination({ pagination, updateParams }) {
  if (!pagination.totalPages || pagination.totalPages <= 1) {
    return null;
  }

  return (
    <Pagination
      className="openings-directory-dsp-pagination"
      onChange={page => updateParams({ page })}
      pagination={pagination}
    />
  );
}

OpeningsDirectoryIndexPagination.propTypes = {
  pagination: PropTypes.shape({
    currentPage: PropTypes.number,
    nextPage: PropTypes.number,
    perPage: PropTypes.number,
    totalCount: PropTypes.number,
    totalPages: PropTypes.number,
  }).isRequired,
  updateParams: PropTypes.func.isRequired,
};

export default OpeningsDirectoryIndexPagination;
